export const CONTRACT_ADDRESS = process.env.CONTRACT_ADDRESS;
